// extracted by mini-css-extract-plugin
export default {"inlineControls":"Inline_inlineControls__mDsJw","isVisibleInlineControls":"Inline_isVisibleInlineControls__FnyO9","control":"Inline_control__05uGu"};